import { RouteButton } from "../../Buttons"
import { GenericTableFactory } from "../../_Shared/Table/Classes/Factory"
/**
 * ### Route for ('/submittals')   
 * 
 * Shows the list of active submittals
 * 
 */

export function SubmittalList() {
    const table = GenericTableFactory.createSubmittalTable("all")

    return (
        <>
            <div className="pt-5 pl-5">
                <h1>Submittals</h1>
            </div>
            
                {table.RenderTable()}

            <div className="flex flex-row justify-center gap-3 m-2">
                <RouteButton route={"/main_menu"} text="Back"/>
            </div>
        </>
    )
}

export function UsersSubmittalList() {
    const table = GenericTableFactory.createSubmittalTable("personal")
    return (
        <>
            <div className="pt-5 pl-5">
                <h1>Submittals</h1>
            </div>

            {table.RenderTable()}

            <div className="flex flex-row justify-center gap-3 m-2">
                <RouteButton route={"/main_menu"} text="Back"/>
            </div>
        </>
    )
}
